import type ApiUrlCreator from "@core-ui/ApiServices/ApiUrlCreator";
import FetchService from "@core-ui/ApiServices/FetchService";
import type { RenderableTreeNodes } from "@ext/markdown/core/render/logic/Markdoc";
import type { FragmentError, FragmentRenderData } from "@ext/markdown/elements/fragment/edit/model/types";

export type ShownFragment = { content: RenderableTreeNodes | null; error?: FragmentError };

type SetContent = (shown: ShownFragment) => void;

const setContents: Map<string, SetContent[]> = new Map();

const keyOf = (id: string, scope?: string) => JSON.stringify([scope ?? null, id]);

async function getContentById(id: string, apiUrlCreator: ApiUrlCreator, scope?: string) {
	if (!scope) await FetchService.fetch(apiUrlCreator.clearArticlesContentWithFragment(id));
	const res = await FetchService.fetch<FragmentRenderData>(apiUrlCreator.getFragmentRenderData(id, scope));
	if (!res.ok) return;
	return res.json();
}

const FragmentUpdateService = {
	addUpdateContent(id: string, SetContent: SetContent, scope?: string) {
		const key = keyOf(id, scope);
		if (setContents.has(key)) setContents.get(key).push(SetContent);
		else setContents.set(key, [SetContent]);
	},

	removeUpdateContent(id: string, SetContent: SetContent, scope?: string) {
		const key = keyOf(id, scope);
		if (!setContents.has(key)) return;
		setContents.set(
			key,
			setContents.get(key).filter((sc) => sc !== SetContent),
		);
	},

	clearContent(id: string, scope?: string) {
		const key = keyOf(id, scope);
		if (!setContents.has(key)) return;
		setContents.get(key).map((f) => f({ content: null }));
	},

	/** A fragment the user may not read answers nothing: its blocks keep what they show. */
	async updateContent(id: string, apiUrlCreator: ApiUrlCreator, scope?: string) {
		const data = await getContentById(id, apiUrlCreator, scope);
		if (!data) return;
		setContents.get(keyOf(id, scope))?.map((f) => f({ content: data.content, error: data.error }));
	},
};

export default FragmentUpdateService;
